import axios from "axios";
import { reportErrorToServer } from "./logger";

/**
 * Handle form submission with file uploads, advanced search, etc.
 * Also supports upload progress: setIsUploading, setUploadProgress
 */
export const handleSubmit = async (
  data,
  dirtyFields,
  methods,
  provID,
  fetchAndSetData,
  setSaving,
  setCheckChange,
  setChangesMade,
  changesMade,
  setUserList,
  existingGalleryImages,
  deletedImageIds,

  // NEW: add these two if you want to track upload progress
  setUploadProgress,
  setIsUploading,
  reset,
  currentValues,
  setUploadError,
  premiumChangesMade
) => {
  // Begin "saving" + "uploading"
  setSaving(true);

  const cleanedData = { ...data };
  const formData = new FormData();

  // Handle "changes made"

  // First get the version number from the back to ensure it's the same version number to ensure cache isn't an issue. This will be logged in the back end

  formData.append("version", window.userInfo.version);

  console.log("CHANGES MADE", changesMade);
  console.log("PREMIUM CHANGES MADE", premiumChangesMade);

  formData.append("changes_made", changesMade);
  formData.append("premium_changes_made", premiumChangesMade);

  console.log("cleaned data", cleanedData);

  /**
   * 1) Advanced search
   */
  if (cleanedData.advanced_search) {
    const advancedSearchObject = Object.keys(cleanedData.advanced_search)
      .filter(key => cleanedData.advanced_search[key])
      .reduce((acc, key, index) => {
        acc[index] = key;
        return acc;
      }, {});
    formData.append("advanced_search", JSON.stringify(advancedSearchObject));
  }

  /**
   * 2) Availability
   */
  if (cleanedData.availability) {
    const submissionAvailability = cleanedData.availability.map(item => {
      const cleanedItem = { ...item };
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const itemDate = new Date(cleanedItem.date_available);
      itemDate.setHours(0, 0, 0, 0);

      console.log("ITEM DATE", itemDate);
      console.log("TODAY", today);

      // If date_available is past, reset to today's date
      if (itemDate < today) {
        console.log("EXPIRED");
        console.log(cleanedItem.date_available);
        console.log(today.toISOString().split("T")[0]);
        cleanedItem.date_available = today.toISOString().split("T")[0];
      }

      // Reimbursement
      if (cleanedItem.reimbursement) {
        cleanedItem.reimbursement = cleanedItem.reimbursement.map(r => r.value);
      }
      // Remove "insurance"?
      delete cleanedItem.insurance;

      return cleanedItem;
    });

    formData.append("availability", JSON.stringify(submissionAvailability));
  }

  /**
   * 3) Amenities & Common Areas
   */
  if (cleanedData.amenities) {
    const amenitiesIndexes = cleanedData.amenities.map((val, idx) => (val === true ? idx : null)).filter(idx => idx !== null);
    const amenities_new = amenitiesIndexes.join(",");
    formData.append("amenities_new", amenities_new);
  }

  if (cleanedData.common_areas) {
    const commonAreasIndexes = cleanedData.common_areas.map((val, idx) => (val === true ? idx : null)).filter(idx => idx !== null);
    const common_areas_new = commonAreasIndexes.join(",");
    formData.append("common_areas_new", common_areas_new);
  }

  /**
   * 4) Services
   */
  if (cleanedData.services) {
    const servicesIndexes = cleanedData.services.map((val, idx) => (val === true ? idx : null)).filter(idx => idx !== null);
    const services_new = servicesIndexes.join(",");
    formData.append("services_new", services_new);
  }

  /**
   * 5) Users
   */
  if (cleanedData.users) {
    formData.append("users", JSON.stringify(cleanedData.users));
  }

  /**
   * 6) Premium Data
   */
  if (cleanedData.premium) {
    Object.keys(cleanedData.premium).forEach(key => {
      const value = cleanedData.premium[key];

      if (key === "company_logo") {
        // Make sure we have a valid File object
        if (value) {
          if (value instanceof File) {
            formData.append(key, value, value.name); // Add filename as third parameter
          } else if (Array.isArray(value) && value[0] instanceof File) {
            formData.append(key, value[0], value[0].name);
          } else if (value && typeof value === "object" && value.name) {
            formData.append(key, value);
          } else {
            console.error("Invalid company_logo value:", value);
          }
        }
      } else if (key === "company_brochure") {
        if (value) {
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else if (Array.isArray(value) && value.length > 0) {
            if (value[0] instanceof File) {
              formData.append(key, value[0], value[0].name);
            } else if (value[0] && typeof value[0] === "object" && value[0].name) {
              formData.append(key, value[0]);
            } else {
              console.error("Invalid company_brochure value:", value);
            }
          } else if (value && typeof value === "object" && value.name) {
            formData.append(key, value);
          } else {
            console.error("Invalid company_brochure value:", value);
          }
        }
      } else if (key === "floor_plan") {
        if (value) {
          if (value instanceof File) {
            formData.append(key, value, value.name);
          } else if (Array.isArray(value) && value.length > 0) {
            if (value[0] instanceof File) {
              formData.append(key, value[0], value[0].name);
            } else if (value[0] && typeof value[0] === "object" && value[0].name) {
              formData.append(key, value[0]);
            } else {
              console.error("Invalid floor_plan value:", value);
            }
          } else if (value && typeof value === "object" && value.name) {
            formData.append(key, value);
          } else {
            console.error("Invalid floor_plan value:", value);
          }
        }
      } else if (key === "full_gallery" && Array.isArray(value)) {
        // If the array is empty, skip entirely
        if (!value.length) {
          // No gallery items to upload
        } else {
          value.forEach((image, index) => {
            if (!image) {
              // If it's null or undefined, skip it
              return;
            } else if (image instanceof File) {
              formData.append("company_photos[]", image, image.name);
            } else if (image && image.file instanceof File) {
              formData.append("company_photos[]", image.file, image.file.name);
            } else if (image && typeof image === "object" && image.file && typeof image.file === "object" && image.file.name) {
              formData.append("company_photos[]", image.file);
            } else {
              console.error(`Invalid gallery image at index ${index}:`, image);
            }
          });
        }
      } else {
        // Non-file fields
        formData.append(key, value);
      }
    });

    const deletedIds = cleanedData.premium.deleted_image_ids || [];
    if (deletedIds.length > 0) {
      formData.append("deleted_image_ids", JSON.stringify(deletedIds));
    }

    //console.log("DESCRIPTION PREVIOUSLY", cleanedData.premium.company_description);

    // Normalize company_description by replacing one or more newlines with a space

    ///cleanedData.premium.company_description = cleanedData.premium.company_description.replace(/\n{2,}/g, "\n");

    //console.log("DESCRIPTION POST", cleanedData.premium.company_description);

    formData.append("company_description", cleanedData.premium.company_description);
  }

  /**
   * 7) Everything else
   */

  // check to see if premium has any files to be uploaded

  let hasFiles = false;

  if (cleanedData.premium) {
    const { company_logo, company_brochure, floor_plan, full_gallery } = cleanedData.premium;

    if (company_logo || company_brochure || floor_plan) {
      // If they exist, they are typically arrays with the actual file in index 0
      hasFiles = true;
    }

    if (full_gallery && full_gallery.some(item => item.file)) {
      hasFiles = true;
    }
  }

  if (hasFiles && setIsUploading) {
    setIsUploading(true);
  }

  if (hasFiles && setUploadProgress) {
    setUploadProgress(0);
  }

  Object.keys(cleanedData).forEach(key => {
    // Exclude these items, since we've handled them above
    if (!["premium", "advanced_search", "availability", "users"].includes(key)) {
      formData.append(key, cleanedData[key]);
    }
  });

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
      "X-WP-Nonce": window.userInfo.nonce
    }
  };

  if (hasFiles && setUploadProgress) {
    axiosConfig.onUploadProgress = progressEvent => {
      if (progressEvent.total) {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percent);
      }
    };
  }

  // Debug FormData
  // console.log("===== FormData about to be sent =====");
  // for (let [key, value] of formData.entries()) {
  //   console.log(key, value);
  // }
  // console.log("=====================================");

  try {
    const response = await axios.post(`/wp-json/provider/v1/update_db_provider/${provID}`, formData, axiosConfig);

    // Refresh data
    await fetchAndSetData(provID);

    // Clear any existing error here
    if (setUploadError) {
      setUploadError("");
    }

    console.log("response", response);

    // Reset all the premium fields after successful submission

    console.log("=========================Current form values before reset:", currentValues());
    console.log("CLEANED DATA", cleanedData.availability);

    // reset({
    //   ...currentValues(),
    //   premium: {
    //     company_logo: null,
    //     company_brochure: null,
    //     floor_plan: null,
    //     full_gallery: []
    //   }
    // });

    methods.setValue("premium.company_logo", null, { shouldDirty: false });
    methods.setValue("premium.company_brochure", null, { shouldDirty: false });
    methods.setValue("premium.floor_plan", null, { shouldDirty: false });
    methods.setValue("premium.full_gallery", [], { shouldDirty: false });

    console.log("=========================Current form values AFTER reset:", currentValues());

    console.log("CLEANED DATA AFTER RESET", cleanedData.availability);
  } catch (error) {
    console.error("Request failed:", error);

    if (setUploadError) {
      // Try to read a message from the server, or default to a fallback
      const backendMessage = error.response?.data?.message || "An unknown error occurred.";
      setUploadError(backendMessage);

      const errorDetails = {
        error: backendMessage,
        data: formData,
        providerID: provID,
        userID: window.userInfo.ID,
        userRole: window.userInfo.role,
        version: window.userInfo.version
      };

      // Report error to server
      reportErrorToServer(errorDetails);
    }
  } finally {
    // Stop "saving" + "uploading"
    setSaving(false);
    setCheckChange(false);
    setChangesMade(false);

    if (setIsUploading) {
      setIsUploading(false);
    }
  }
};
